import { useCallback } from "react";

import { CallbackTrack } from "hooks/useAnalytics";
import useTypedContext from "hooks/useTypedContext";
import { ApplyFiltersContext } from "components/Filters";
import { FiltersDictionary } from "components/Filters/types";

type MakeUseLabelCellFilterActionProps = {
  trackAnalytics: CallbackTrack;
  searchSuggestionsDictionary: FiltersDictionary;
};

export type UseLabelCellFilterActionProps = {
  labelCell?: boolean;
};

type LabelCellFilterActionProps = {
  filterName: string;
  filterValue: string;
  analyticTitle?: string;
};

const makeUseLabelCellFilterAction = ({
  trackAnalytics,
  searchSuggestionsDictionary,
}: MakeUseLabelCellFilterActionProps) => {
  const useCellFilterAction = ({ labelCell = false }: UseLabelCellFilterActionProps = {}) => {
    const { applyFilter, applyLabelFilter } = useTypedContext(ApplyFiltersContext);

    const filterAction = labelCell ? applyLabelFilter : applyFilter;

    const makeCellFilterAction = useCallback(
      ({
        filterName,
        filterValue,
        analyticTitle = "Add to filters clicked",
      }: LabelCellFilterActionProps) => {
        filterAction(filterName, searchSuggestionsDictionary)(filterValue);
        trackAnalytics(analyticTitle, { type: filterName });
      },
      [filterAction]
    );

    return makeCellFilterAction;
  };

  return useCellFilterAction;
};

export default makeUseLabelCellFilterAction;
